module.exports = __webpack_public_path__ + "static/media/student-code.3d44dc7a.png";